import React, { useEffect } from 'react';
import { useSEO } from '../../hooks/useSEO';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GoogleAnalytics: React.FC = () => {
  const { seoSettings } = useSEO();

  useEffect(() => {
    if (!seoSettings?.analytics?.googleAnalyticsId) return;

    // Google Analytics script'ini ekle
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${seoSettings.analytics.googleAnalyticsId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${seoSettings.analytics.googleAnalyticsId}');
    `;
    document.head.appendChild(script2);

    return () => {
      // Cleanup
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, [seoSettings?.analytics?.googleAnalyticsId]);

  // Google Tag Manager
  useEffect(() => {
    if (!seoSettings?.analytics?.googleTagManagerId) return;

    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${seoSettings.analytics.googleTagManagerId}');
    `;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [seoSettings?.analytics?.googleTagManagerId]);

  return null;
};

export default GoogleAnalytics; 